import React from 'react'
import NextLink from 'next/link'
import NextImage from 'next/image'
import styled from '@emotion/styled'
import useConfig from '../../../config/state/use-config'

interface StepLayoutRootProps {
  children: React.ReactNode
}

export default function StepLayoutRoot({ children }: StepLayoutRootProps) {
  const config = useConfig()

  return (
    <Root>
      <Header>
        <NextLink href={config.header.logoLink} title={config.header.logoAltText}>
          <Logo
            height={36}
            width={72}
            alt={config.header.logoAltText}
            src={config.header.logoAssetUrl}
          />
        </NextLink>
      </Header>
      <Main>{children}</Main>
    </Root>
  )
}

const Root = styled.div`
  gap: 64px;
  display: flex;
  flex-direction: column;
`

const Header = styled.header`
  top: 0;
  display: flex;
  height: 64px;
  padding: 0 16px;
  position: sticky;
  align-items: center;
  background-color: white;
  border-bottom: 1px solid #eaeaea;
`

const Logo = styled(NextImage)``

const Main = styled.main`
  padding: 0 16px;
`
